/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2022 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import React, {useRef, useState} from 'react';
import {ReactComponent as Search} from "../../assets/img/icons/search-white.svg";
import {ReactComponent as CheckboxEmpty} from "../../assets/img/forms/checkbox-empty.svg";
import {ReactComponent as CheckboxFull} from "../../assets/img/forms/checkbox-full.svg";
import {ReactComponent as Camera} from "../../assets/img/icons/camera.svg";
import LoginModal from "../../components/LoginModal";
import Loader from "../../elements/loader";
import {useAuth} from "../../Hooks/useAuth";
import useAxiosJTW from "../../Hooks/useAxiosJTW";
import {useTranslation} from "react-i18next";
import {Link, useParams} from "react-router-dom";

const AvailableParts = (props) => {

    const user = useAuth();
    const partsForm = useRef(null);
    const axiosJWT = useAxiosJTW();
    let params = useParams();
    const { t, i18n } = useTranslation();

    const [selectedParts, setSelectedParts] = useState([]);
    const [searchValue, setSearchValue] = useState('');
    const [showLoginModal, setShowLoginModal] = useState(false);
    const [requestStatus, setRequestStatus] = useState(0); //1: success, 2: error, 3: loader

    const sendpartemailrequest = (parts) => {
        setRequestStatus(3);
        axiosJWT.post('api/sendpartemailrequest', {parts: parts, user_id: user.profile.user_id, ads_id: props.ad.ads_id, merchant_email: props.merchantInfo.email, code: props.ad.code}).then( (response) => {
            if(response.status === 200){
                setRequestStatus(1);
                partsForm.current.reset();
                setSelectedParts([]);
            }else{
                setRequestStatus(2);
            }
        }).catch( (error) => {
            setRequestStatus(2);
        } );
    }

    const filterNames = ({ title }) => {
        return title.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1;
    };
    const filterRows = ({ parts }) => {
        let flag = [];
        parts.map( (part, index) => {
            part.title.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1 ? flag.push('has') : '';
        });
        return flag.includes('has');
    };

    const onPartChange = (e) => {
        if( e.target.checked === true ){
            setSelectedParts([...selectedParts, e.target.value]);
        }else{
            let array = [...selectedParts];
            let index = array.indexOf(e.target.value);
            if (index !== -1) {
                array.splice(index, 1);
                setSelectedParts(array);
            }
        }
    }

    const submitRequest = () => {
        sendpartemailrequest(selectedParts);
    }

    return (
        <>
            <div className='searchParts'>
                <div className='searchParts__row'>
                    <div className='searchParts__label'>
                        <div className='searchParts__label-inner'>{ t('parts.FindyourPart' ) }</div>
                    </div>
                    <div className='searchParts__element'>
                        <div className='searchParts__element-inner'>
                            <div className='searchParts__box'>
                                <input type='text' className='form-control' onChange={ (e) => { setSearchValue(e.target.value) } } placeholder={ t('parts.SearchAvailable' ) }  />
                                <div className='searchParts__icon'><Search/></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='listngParts'>
                <div className='listngParts__header'>
                    <div className='listngParts__title'>{ t('parts.ListingofAvailableParts' ) } </div>
                    <div className='listngParts__header-checkbox'>
                        {/*<label className="custom-checkbox">*/}
                        {/*    <input type="checkbox" className=""/>*/}
                        {/*    <span className="custom-checkbox__icon custom-checkbox__empty"><CheckboxEmpty/></span>*/}
                        {/*    <span className="custom-checkbox__icon custom-checkbox__checked"><CheckboxFull/></span>*/}
                        {/*    NOT AVAILABLE*/}
                        {/*</label>*/}
                    </div>
                </div>

                <div className='listngParts__body'>
                    <form ref={partsForm}>
                        { Object.keys(props.parts).map( (key, index) => {
                            if(props.parts[key].subcategories.length > 0){
                                return(
                                    <div className={`listngPartItem ${props.parts[key].subcategories.filter(filterRows).length > 0 ? "" : "listngPartItem--hide"}`} key={index}>
                                        <div className='listngPartItem__header'>
                                            <span className='listngPartItem__icon'><img src={props.parts[key].image} alt={props.parts[key].part_category_title}/> </span>
                                            <span className='listngPartItem__label text--title'>{props.parts[key].part_category_title}</span>
                                        </div>
                                        <div className='listngPartItem__body'>
                                            <div className="row">
                                                { props.parts[key].subcategories.map( (subcategory, index2) => {
                                                    if(subcategory.parts.length > 0){
                                                        return (
                                                            <div className="col-12 col-md-6 col-lg-4 mb-4" key={index2}>
                                                                <div className='font-weight-bold mb-3'>{subcategory.part_category_title}</div>
                                                                { subcategory.parts.filter(filterNames).map( (part, index3) => (
                                                                    <div className="d-flex align-items-center mb-2" key={index3}>
                                                                        <label className="custom-checkbox">
                                                                            <input type="checkbox" value={part.ads_parts_id} onChange={(e) => { onPartChange(e) }}/>
                                                                            <span className="custom-checkbox__icon custom-checkbox__empty mr-2"><CheckboxEmpty/></span>
                                                                            <span className="custom-checkbox__icon custom-checkbox__checked mr-2"><CheckboxFull/></span>
                                                                        </label>

                                                                        <Link to={`/${i18n.language}/used-part/${part.slug}/${params.make}/${params.model}/${params.year}/${params.city}/${part.code}`}>{part.title} {part.specs && <span>&nbsp;({part.specs})</span>} </Link>

                                                                        { part.images.length > 0 && <div className="imageBox">
                                                                            <div className=''><Camera/></div>
                                                                            <div className="imageBox__body">
                                                                                <div className="row extra-small-gutters">
                                                                                    {
                                                                                        part.images.map((item, index) => {
                                                                                            return(
                                                                                            <div className='col-auto' key={index}>
                                                                                                <div className="img-sample mb-2"><img className="max-h-40" src={item.image} alt='parts'/></div>
                                                                                            </div>
                                                                                            );
                                                                                        })
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                        </div>}
                                                                    </div>
                                                                ) )}
                                                            </div>
                                                        )
                                                    }
                                                } )}
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        } )}
                    </form>
                </div>

                <div className='listngParts__footer'>
                    {user.profile.isLogged
                        ? <button className='btn btn-primary btn-parts-request' disabled={selectedParts.length > 0 ? '' : true} onClick={submitRequest}>{ t('parts.SENDREQUEST' ) } { selectedParts.length > 0 && <span>({selectedParts.length })</span> }</button>
                        : <LoginModal showModal={showLoginModal} buttonText={ t('parts.SENDREQUEST' ) } />
                    }
                </div>

                <div className='pt-3'>
                    <div className="row justify-content-end">
                        <div className='col-md-6 col-xl-4'>
                            { requestStatus == 3 && <div className='small' style={{ textAlign : 'center', margin: '0 auto' }}><Loader/></div> }
                            { requestStatus == 1 && <div className="alert alert-success text-center" role="alert">
                                Request has been send
                            </div>}
                            { requestStatus == 2 && <div className="alert alert-danger text-center" role="alert">
                                {t('parts.reqerror')}
                            </div>}
                        </div>
                    </div>
                </div>

            </div>
        </>
    );
};

export default AvailableParts;